import { useState } from "react"
import CustomHr from "./CustomHr"
import NewOptionValue from "./NewOptionValue";

const AddCustomOptions = ({ inputData, setInputData }) => {
    // Handle Custom Options input
    const [newKeyInput, setNewKeyInput] = useState(null);
    const handleKeyInput = (event) => {
        const { value } = event.target;
        setNewKeyInput(prevState => (value)
        )
    }

    // Gestisco l'aggiunta di una nuova opzione
    const handleAddCustomOption = () => {
        setInputData(prevState => {
            let newObject = { title: newKeyInput, values: [] };
            return {
                ...prevState,
                customOptions: [...prevState.customOptions, newObject]
            }
        })
        setNewKeyInput(null);
    }

    // Gestisco l'eliminazione di un nuovo Option
    const handleRemoveOption = (string) => {
        let newCustomOptions = inputData.customOptions.filter(element => element.title !== string);
        setInputData(prevState => ({
            ...prevState,
            customOptions: newCustomOptions
        }))
    }

    return (
        <div className="w-full">
            {/* Aggiungi opzioni personalizzate */}
            <h2 className="mt-8">Opzioni personalizzate</h2>
            <CustomHr />


            <div className="flex flex-col p-2 gap-2 w-full lg:w-fit border border-[#225424] rounded">
                <label htmlFor="description" className="text-2xl">Aggiungi nuova opzione</label>
                <h5>(Scrivi il titolo e aggiungi una nuova opzione. Poi inserisci le singole voci)</h5>
                <div className="flex gap-2 max-w-[800px] lg:w-[800px]">
                    <input id="customOptionKey" type="text" className="flex-grow" onChange={handleKeyInput} value={newKeyInput ? newKeyInput : ''} />
                    {newKeyInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-[#225424] text-[#225424] flex justify-center items-center text-4xl pb-1" onClick={handleAddCustomOption}>+</button>}
                    {!newKeyInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-neutral-300 text-neutral-300 flex justify-center items-center text-4xl pb-1 cursor-not-allowed">+</button>}
                </div>
                <div className="border-2 p-2 flex flex-col gap-2 min-h-[72px] rounded">
                    {
                        inputData.customOptions && inputData.customOptions.length > 0 && inputData.customOptions.map((element, index) => {
                            return <NewOptionValue key={index} index={index} title={element.title} close={handleRemoveOption} inputData={inputData} setInputData={setInputData}/>
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default AddCustomOptions